import type { ApiResponse, SeoConfig } from '@klaro7/shared-types';

import api from '@/lib/api';

export async function getPublicSeoConfig(): Promise<SeoConfig> {
  const response = await api.get<ApiResponse<SeoConfig>>('/seo/public');
  return response.data.data;
}

export async function getSeoConfig(): Promise<SeoConfig> {
  const response = await api.get<ApiResponse<SeoConfig>>('/seo');
  return response.data.data;
}

export async function updateSeoConfig(payload: Partial<SeoConfig>): Promise<SeoConfig> {
  const response = await api.put<ApiResponse<SeoConfig>>('/seo', payload);
  return response.data.data;
}

export async function uploadSeoImage(file: File): Promise<{ url: string }> {
  const formData = new FormData();
  formData.append('image', file);
  const response = await api.post<ApiResponse<{ url: string }>>('/seo/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data.data;
}
